module.exports = __webpack_public_path__ + "img/icon_hotbrand.74d5788a.png";